import { TaxiPonto } from '@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-ponto.entity';
import { TaxiParada } from "@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-parada.entity";

export class TaxiParadaDTO extends TaxiParada{
    cdPonto: number;
    cdParada: number;
    cdConcessao: number;
    nrParada: string;
    cdConcessionario: number;
    idPonto: string;
    cdPessoa: number;
    nmPessoa: string;
    qtVagas: number;
    taxiPonto: TaxiPonto;

    constructor(
        cdPonto?: number,
        cdParada?: number,
        cdConcessao?: number,
        nrParada?: string,
        cdConcessionario?: number,
        idPonto?: string,
        cdPessoa?: number,
        nmPessoa?: string,
        qtVagas?: number,
        taxiPonto?: TaxiPonto
        
    ){
        super();
        this.cdPonto = cdPonto;
        this.cdParada = cdParada;
        this.cdConcessao = cdConcessao;
        this.nrParada = nrParada;
        this.cdConcessionario = cdConcessionario;
        this.idPonto = idPonto;
        this.cdPessoa = cdPessoa;
        this.nmPessoa = nmPessoa;
        this.qtVagas = qtVagas;
        this.taxiPonto = taxiPonto;
    }

    
}

export class TaxiParadaListDTO{
    items: Array<TaxiParadaDTO>;
    total: number;
    constructor() {}
}